<template>
  <div class="tabs_content">
    <section>
      <div class="left">
        <h2 v-translate>Základní nastavení</h2>
      </div>
      <div class="right">
        <div class="field_left">
          <select-box
              id="search_in_locked_content_selectbox"
              :options="searchInLockedChannelsOptions"
              v-model="searchInLockedChannels"
              :disabled="!isEditable"
              @input="_searchInLockedChannelsOptionChanged">

            <translate class="translate">Hledat v zamčených kanálech</translate>
          </select-box>
          <div class="field">
            <input :disabled="!isEditable || !!!entity.platform.search_in_locked_tv_stations"
                   @change="_onDefaultSearchInLockedChannelsChanged" type="checkbox" id="search_in_locked_channels"
                   name="search_in_locked_channels"
                   :checked="entity.platform.search_in_locked_tv_stations ? entity.platform.search_in_locked_tv_stations.editable : false">
            <label for="search_in_locked_channels" v-translate>Povolit změnu hledání v zamčených kanálech</label>
          </div>
        </div>

        <div class="field_right">
          <select-box
              id="tv_button_function"
              :options="tvButtonShowsOptions"
              v-model="tvButtonShows"
              :disabled="!isEditable"
              @input="_tvButtonShowsChanged">

            <translate class="translate">Funkce tlačítka TV</translate>
          </select-box>
          <div class="field">
            <input :disabled="!isEditable || !!!entity.platform.tv_button_shows"
                   @change="_onDefaultTvButtonsShowsChanged" type="checkbox" id="tv_button_functions"
                   name="tv_button_functions"
                   :checked="entity.platform.tv_button_shows ? entity.platform.tv_button_shows.editable : false">
            <label for="tv_button_functions" v-translate>Povolit změnu funkce tlačítka TV</label>
          </div>
        </div>
      </div>
    </section>

    <SettingsTable
        :is-editable="isEditable"
        :title="$gettext('Řazení nahrávek')"
        :value-label="$gettext('Přidat volbu')"
        :settingsObject="this.entity.platform['pvr_ordering_type']"
        sorting-key="pvr_ordering_type"
        :fixed-values="availableValues.pvrs_ordering_type_values"
        @addValue="_onAddValueToPvrOrdering"
        @editableChanged="_onEditablePvrOrderingChanged"
        @defaultValueChanged="_onDefaultPvrOrderingChanged"
        @removeValueByIndex="_onRemoveValueByIndexFromPvrOrdering"
        @valuesSorted="_onValuesPvrOrderingSorted"
        :nameTransformFunction="_getPvrOrderingName"
    />

    <SettingsTable
        :is-editable="isEditable"
        :title="$gettext('Preferované pořadí zvuku')"
        :value-label="$gettext('Jazyk')"
        :settingsObject="this.entity.platform['preferred_audio_language']"
        sorting-key="preferred_audio_language"
        :fixed-values="availableValues.allowed_device_languages"
        @addValue="_onAddValueToPreferredAudioLanguage"
        @editableChanged="_onEditablePreferredAudioLanguageChanged"
        @defaultValueChanged="_onDefaultPreferredAudioLanguageChanged"
        @removeValueByIndex="_onRemoveValueByIndexFromPreferredAudioLanguage"
        @valuesSorted="_onValuesPreferredAudioLanguageSorted"
        :nameTransformFunction="getLanguageNameByCode"
    />

    <ContentLanguagePresets
        :entity="entity"
        :isEditable="isEditable"
    />

    <SettingsTable
        :is-editable="isEditable"
        :title="$gettext('Výchozí obrazovka po startu zařízení')"
        :value-label="$gettext('Přidat volbu')"
        :settingsObject="this.entity.platform['default_screen']"
        sorting-key="default_screen"
        :fixed-values="availableValues.default_screens_values"
        @addValue="_onAddValueToDefaultScreen"
        @editableChanged="_onEditableDefaultScreenChanged"
        @defaultValueChanged="_onDefaultDefaultScreenChanged"
        @removeValueByIndex="_onRemoveValueByIndexFromDefaultScreen"
        @valuesSorted="_onValuesDefaultScreenSorted"
        :nameTransformFunction="_getDefaultScreenValueName"
    />

    <SettingsTable
        :is-editable="isEditable"
        :title="$gettext('Minimální délka rozkoukaného pořadu (m)')"
        :value-label="$gettext('Hodnota (m)')"
        :settingsObject="this.entity.platform['minimal_broadcast_length_in_minutes']"
        sorting-key="minimal_broadcast_length_in_minutes"
        @addValue="_onAddValueToMinimalBroadcastLengthInMinutes"
        @editableChanged="_onEditableMinimalBroadcastLengthInMinutesChanged"
        @defaultValueChanged="_onDefaultMinimalBroadcastLengthInMinutesChanged"
        @removeValueByIndex="_onRemoveValueByIndexFromMinimalBroadcastLengthInMinutes"
        @valuesSorted="_onValuesMinimalBroadcastLengthInMinutesSorted"
    />

  <SettingsTable
        :is-editable="isEditable"
        :title="$gettext('Minimální délka sledování rozkoukaného pořadu (m)')"
        :value-label="$gettext('Hodnota (m)')"
        :settingsObject="this.entity.platform['minimal_play_time_length_in_minutes']"
        sorting-key="minimal_play_time_length_in_minutes"
        @addValue="_onAddValueToMinimalPlayTimeLengthInMinutes"
        @editableChanged="_onEditableMinimalPlayTimeLengthInMinutesChanged"
        @defaultValueChanged="_onDefaultMinimalPlayTimeLengthInMinutesChanged"
        @removeValueByIndex="_onRemoveValueByIndexFromMinimalPlayTimeLengthInMinutes"
        @valuesSorted="_onValuesMinimalPlayTimeLengthInMinutesSorted"
  />
  </div>
</template>

<script>
import formFilterData from "@/components/mixins/form-filter-data"
import settingsMixins from "../mixins/settings";
import SettingsTable from "../../../common/SettingsTable.vue";
import ContentLanguagePresets from "./ContentLanguagePresets";
import languages from "../../../mixins/languages";

export default {
  name: "Platform",
  components: {SettingsTable, ContentLanguagePresets},
  mixins: [formFilterData, settingsMixins, languages],
  props: {
    entity: Object,
    isEditable: Boolean,
    availableValues: Object
  },
  data() {
    return {
      searchInLockedChannels: this.entity.platform.search_in_locked_tv_stations ? this.entity.platform.search_in_locked_tv_stations.default : null,
      tvButtonShows: this.entity.platform.tv_button_shows ? this.entity.platform.tv_button_shows.default : null,
    }
  },
  methods: {
    _searchInLockedChannelsOptionChanged(value) {
      if (value === null) {
        this._deleteSubkey('platform', 'search_in_locked_tv_stations');
      } else {
        this._defaultValueChanged('platform', 'search_in_locked_tv_stations', value === 'true', [true, false]);
      }
    },
    _onDefaultSearchInLockedChannelsChanged(event) {
      this._editableChanged('platform', 'search_in_locked_tv_stations', event.target.checked, [true, false]);
    },
    _tvButtonShowsChanged(value) {
      if (value === null) {
        this._deleteSubkey('platform', 'tv_button_shows');
      } else {
        this._defaultValueChanged('platform', 'tv_button_shows', value, this.tvButtonShowsAvailableValues);
      }
    },
    _onDefaultTvButtonsShowsChanged(event) {
      this._editableChanged('platform', 'tv_button_shows', event.target.checked, this.tvButtonShowsAvailableValues);
    },
    _getTvButtonShowValueName(value) {
      switch (value) {
        case 'epg':
          return this.$gettext('EPG');
        case 'programs_on_channel':
          return this.$gettext('Pořady na kanálu');
        case 'dashboard':
          return this.$gettext('Domovská stránka');
        default:
          return value;
      }
    },
    _onAddValueToPvrOrdering(value) {
      this._addValue('platform', 'pvr_ordering_type', value);
    },
    _onEditablePvrOrderingChanged(value) {
      this._editableChanged('platform', 'pvr_ordering_type', value === 'true');
    },
    _onDefaultPvrOrderingChanged(value) {
      this._defaultValueChanged('platform', 'pvr_ordering_type', value);
    },
    _onRemoveValueByIndexFromPvrOrdering(index) {
      this._removeValueByIndex('platform', 'pvr_ordering_type', index);
    },
    _onValuesPvrOrderingSorted(values) {
      this._replaceValues('platform', 'pvr_ordering_type', values);
    },
    _getPvrOrderingName(value) {
      switch (value) {
        case 'alphabetical_asc':
          return this.$gettext('Název vzestupně');
        case 'alphabetical_desc':
          return this.$gettext('Název sestupně');
        case 'broadcast_time_asc':
          return this.$gettext('Čas vzestupně');
        case 'broadcast_time_desc':
          return this.$gettext('Čas sestupně');
        case 'expiration_date_asc':
          return this.$gettext('Čas do smazání vzestupně');
        case 'expiration_date_desc':
          return this.$gettext('Čas do smazání sestupně');
        case 'creation_date_asc':
          return this.$gettext('Čas uložení vzestupně');
        case 'creation_date_desc':
          return this.$gettext('Čas uložení sestupně');
        default:
          return value;
      }
    },
    _onAddValueToPreferredAudioLanguage(value) {
      this._addValue('platform', 'preferred_audio_language', value);
    },
    _onEditablePreferredAudioLanguageChanged(value) {
      this._editableChanged('platform', 'preferred_audio_language', value === 'true');
    },
    _onDefaultPreferredAudioLanguageChanged(value) {
      this._defaultValueChanged('platform', 'preferred_audio_language', value);
    },
    _onRemoveValueByIndexFromPreferredAudioLanguage(index) {
      this._removeValueByIndex('platform', 'preferred_audio_language', index);
    },
    _onValuesPreferredAudioLanguageSorted(values) {
      this._replaceValues('platform', 'preferred_audio_language', values);
    },
    _onAddValueToMinimalBroadcastLengthInMinutes(value) {
      this._addValue('platform', 'minimal_broadcast_length_in_minutes', ~~value);
    },
    _onEditableMinimalBroadcastLengthInMinutesChanged(value) {
      this._editableChanged('platform', 'minimal_broadcast_length_in_minutes', value === 'true');
    },
    _onDefaultMinimalBroadcastLengthInMinutesChanged(value) {
      this._defaultValueChanged('platform', 'minimal_broadcast_length_in_minutes', ~~value);
    },
    _onRemoveValueByIndexFromMinimalBroadcastLengthInMinutes(index) {
      this._removeValueByIndex('platform', 'minimal_broadcast_length_in_minutes', index);
    },
    _onValuesMinimalBroadcastLengthInMinutesSorted(values) {
      this._replaceValues('platform', 'minimal_broadcast_length_in_minutes', values.map(Number));
    },
    _onAddValueToMinimalPlayTimeLengthInMinutes(value) {
      this._addValue('platform', 'minimal_play_time_length_in_minutes', ~~value);
    },
    _onEditableMinimalPlayTimeLengthInMinutesChanged(value) {
      this._editableChanged('platform', 'minimal_play_time_length_in_minutes', value === 'true');
    },
    _onDefaultMinimalPlayTimeLengthInMinutesChanged(value) {
      this._defaultValueChanged('platform', 'minimal_play_time_length_in_minutes', ~~value);
    },
    _onRemoveValueByIndexFromMinimalPlayTimeLengthInMinutes(index) {
      this._removeValueByIndex('platform', 'minimal_play_time_length_in_minutes', index);
    },
    _onValuesMinimalPlayTimeLengthInMinutesSorted(values) {
      this._replaceValues('platform', 'minimal_play_time_length_in_minutes', values.map(Number));
    },
    _onAddValueToDefaultScreen(value) {
      this._addValue('platform', 'default_screen', value);
    },
    _onEditableDefaultScreenChanged(value) {
      this._editableChanged('platform', 'default_screen', value === 'true');
    },
    _onDefaultDefaultScreenChanged(value) {
      this._defaultValueChanged('platform', 'default_screen', value);
    },
    _onRemoveValueByIndexFromDefaultScreen(index) {
      this._removeValueByIndex('platform', 'default_screen', index);
    },
    _onValuesDefaultScreenSorted(values) {
      this._replaceValues('platform', 'default_screen', values);
    },
    _getDefaultScreenValueName(value) {
      switch (value) {
        case 'dashboard':
          return this.$gettext('Dashboard');
        case 'epg':
          return this.$gettext('EPG');
        case 'live':
          return this.$gettext('Live');
        case 'player':
          return this.$gettext('Přehrávač');
        case 'menu':
          return this.$gettext('Menu');
        case 'vod':
          return this.$gettext('Videotéka');
        default:
          return value;
      }
    },
  },
  computed: {
    tvButtonShowsAvailableValues() {
      return this.availableValues.tv_button_shows_values;
    },
    defaultScreensAvailableValues() {
      return this.availableValues.default_screens_values;
    },
    searchInLockedChannelsOptions() {
      return [{
        id: null,
        text: this.$gettext('Neuplatňuje se')
      },
        {
          id: false,
          text: this.$gettext('Ne')
        }, {
          id: true,
          text: this.$gettext('Ano')
        }];
    },
    tvButtonShowsOptions() {
      const values = [{
        id: null,
        text: this.$gettext('Neuplatňuje se')
      }];

      this.tvButtonShowsAvailableValues.forEach((availableValue) => {
        values.push({
          id: availableValue,
          text: this._getTvButtonShowValueName(availableValue)
        })
      });

      return values;
    },
    defaultScreenOptions() {
      const values = [{
        id: null,
        text: this.$gettext('Neuplatňuje se')
      }];

      this.defaultScreensAvailableValues.forEach((availableValue) => {
        values.push({
          id: availableValue,
          text: this._getDefaultScreenValueName(availableValue)
        })
      });

      return values;
    },
  },
  watch: {
    'entity.platform.search_in_locked_tv_stations'() {
      this.searchInLockedChannels = this.entity.platform.search_in_locked_tv_stations ? this.entity.platform.search_in_locked_tv_stations.default : null;
    },
    'entity.platform.tv_button_shows'() {
      this.tvButtonShows = this.entity.platform.tv_button_shows ? this.entity.platform.tv_button_shows.default : null;
    },
  }
}
</script>



// WEBPACK FOOTER //
// src/components/views/deviceConfigs/forms/Platform.vue